var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$mq !== "mobile"
    ? _c(
        "nav",
        { staticClass: "grey-background", class: _vm.checkoutHeaderStyle() },
        [
          _c(
            "div",
            {
              staticClass: "columns is-centered is-flex-mobile ",
              attrs: { id: "checkout-header" }
            },
            [
              _c(
                "div",
                { staticClass: "column is-vertical-center is-paddingless" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "store-navigation-color",
                      attrs: { to: _vm.getRoute() }
                    },
                    [
                      _c("BaseBackButton", {
                        attrs: { title: "Back", click: _vm._navigateToHome }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "column is-vertical-center" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "navbar-item navbar-item--logo",
                      attrs: {
                        to: _vm.getRoute(),
                        exact: "",
                        "aria-label": _vm.getStoreName + " home"
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "navbar-item--logo",
                        attrs: {
                          alt: _vm.getStoreName + " image",
                          src: require("../../assets/store-logo.png")
                        },
                        on: { load: _vm.logoLoaded }
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "column" })
            ]
          )
        ]
      )
    : _c(
        "nav",
        {
          staticClass: "navbar navbar--border navbar--height navbar--mobile",
          class: {
            "has-text-centered": _vm.currentRoute.name === "order-confirmation"
          },
          attrs: { role: "navigation", "aria-label": "main navigation" }
        },
        [
          _c("ul", { staticClass: "navbar-list--inline" }, [
            _c("div", { staticClass: "navbar-item" }, [
              _vm.displayBackButton()
                ? _c(
                    "div",
                    { staticClass: "back-button-wrapper" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "store-navigation-color",
                          attrs: { to: _vm.getRoute() }
                        },
                        [_c("BaseBackButton", { attrs: { title: "Back" } })],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.showLogo
              ? _c(
                  "div",
                  { staticClass: "navbar-item" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "logo-container",
                        class: {
                          "checkout-header":
                            _vm.currentRoute.name !== "order-confirmation"
                        },
                        attrs: { to: _vm.getRoute() }
                      },
                      [
                        _c("img", {
                          staticClass: "navbar-item--logo",
                          class: {
                            "order-confirm-logo":
                              _vm.currentRoute.name === "order-confirmation"
                          },
                          attrs: {
                            src: require("../../assets/store-logo.png")
                          },
                          on: { load: _vm.logoLoaded }
                        })
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "navbar-item" }, [_c("account-menu")], 1)
          ])
        ]
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3547f79c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3547f79c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/CheckoutHeader.vue
// module id = null
// module chunks = 